import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24656 16385"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#1c1b17;stroke-width:357.328}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970277755648">
        <path
          d="M20716 828c1388-1389 3761-406 3761 1559v11612c0 1963-2373 2946-3761 1559l-6124-6125c-685-684-685-1796 0-2480l6124-6125zM6816 828c1388-1389 3761-406 3761 1559v11612c0 1963-2373 2946-3761 1559L692 9433C8 8749 8 7637 692 6953L6816 828z"
          className="fill stroke1"
          style={{
            strokeWidth: 357.328,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
